var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-list bg-white"},[_c('DoctorCard',{ref:"doctorCard"}),_c('PatientList',{staticClass:"patient_list",on:{"onPatientList":_vm.checkPatientList}}),_c('foot-button',[_c('van-button',{attrs:{"type":"primary","block":"","icon":"plus"},on:{"click":_vm.clickCreatePatient}},[_vm._v("新建患者")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }